/* Aurelia cart drawer - AJAX cart (add / change / remove), free-shipping bar,
   upsell rail. Paired with snippets/cart-drawer.liquid + assets/cart-drawer.css.
   Wired in layout/theme.liquid. Header [data-cart-open] opens; .p2-buy__form submits
   are intercepted into AJAX adds. */
(function () {
  'use strict';

  var FREE_SHIP_CENTS = 5000; // EUR 50 threshold

  var drawer, itemsEl, emptyEl, footEl, shipMsg, shipFill, shipLabel, subtotalEl, upsellEl, railEl;
  var cart = null;
  var busy = false;

  function money(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* ---------- rendering ---------- */

  function render() {
    if (!cart) return;
    var items = cart.items || [];

    // line items
    var html = '';
    items.forEach(function (it, i) {
      var minusIcon = it.quantity > 1
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/></svg>';
      var variantLine = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<div class="cdrawer__item-variant">' + esc(it.variant_title) + '</div>' : '';
      html += '<div class="cdrawer__item" data-line="' + (i + 1) + '">' +
        '<img class="cdrawer__item-img" src="' + (it.image ? esc(it.image) : '') + '" alt="" loading="lazy" />' +
        '<div>' +
          '<a class="cdrawer__item-title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          variantLine +
          '<div class="cdrawer__qty">' +
            '<button type="button" data-qty-minus aria-label="Decrease quantity">' + minusIcon + '</button>' +
            '<span data-qty-val>' + it.quantity + '</span>' +
            '<button type="button" data-qty-plus aria-label="Increase quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
          '</div>' +
        '</div>' +
        '<div class="cdrawer__item-price">' + money(it.final_line_price) + '</div>' +
      '</div>';
    });
    itemsEl.innerHTML = html;

    var isEmpty = items.length === 0;
    emptyEl.hidden = !isEmpty;
    footEl.style.display = isEmpty ? 'none' : '';
    document.querySelector('.cdrawer__ship').style.display = isEmpty ? 'none' : '';

    // subtotal + shipping
    subtotalEl.textContent = money(cart.items_subtotal_price);
    var free = cart.items_subtotal_price >= FREE_SHIP_CENTS;
    shipLabel.textContent = free ? 'Free' : 'Calculated at checkout';

    // free-shipping bar
    var pct = Math.min(100, Math.round((cart.items_subtotal_price / FREE_SHIP_CENTS) * 100));
    shipFill.style.width = pct + '%';
    shipMsg.textContent = free
      ? "You've unlocked free shipping!"
      : 'You are ' + money(FREE_SHIP_CENTS - cart.items_subtotal_price) + ' away from free shipping';

    // upsell: hide products already in cart
    var inCart = {};
    items.forEach(function (it) { inCart[it.product_id] = true; });
    var visible = 0;
    railEl.querySelectorAll('[data-upsell-item]').forEach(function (card) {
      var hide = !!inCart[parseInt(card.getAttribute('data-product-id'), 10)];
      card.hidden = hide;
      if (!hide) visible++;
    });
    upsellEl.hidden = isEmpty || visible === 0;

    // header badges
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = cart.item_count;
      b.hidden = cart.item_count === 0;
    });
  }

  /* ---------- cart API ---------- */

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); return c; }).catch(function () { /* keep last state; badge unchanged */ });
  }

  function changeLine(line, quantity) {
    if (busy) return Promise.resolve();
    busy = true;
    var row = itemsEl.querySelector('[data-line="' + line + '"]');
    if (row) row.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (c) { cart = c; render(); })
      .catch(function (e) {
        if (shipMsg && e && e.description) shipMsg.textContent = e.description;
        return refresh();
      })
      .finally(function () { busy = false; });
  }

  function addVariant(id, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: qty || 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .finally(function () { busy = false; })
      .then(function () { return refresh(); });
  }

  /* ---------- open / close ---------- */

  var lastTrigger = null;
  function open() {
    lastTrigger = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cdrawer-lock');
    var closeBtn = drawer.querySelector('.cdrawer__close');
    if (closeBtn) closeBtn.focus();
    refresh();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cdrawer-lock');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  /* ---------- wiring ---------- */

  document.addEventListener('DOMContentLoaded', function () {
    drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    itemsEl = drawer.querySelector('[data-cart-items]');
    emptyEl = drawer.querySelector('[data-cart-empty]');
    footEl = drawer.querySelector('[data-cart-foot]');
    shipMsg = drawer.querySelector('[data-ship-msg]');
    shipFill = drawer.querySelector('[data-ship-fill]');
    shipLabel = drawer.querySelector('[data-ship-label]');
    subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    upsellEl = drawer.querySelector('[data-upsell]');
    railEl = drawer.querySelector('[data-upsell-rail]');

    // openers (header cart button on every page)
    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    // close: overlay, X, ESC
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // qty steppers + upsell adds (delegated)
    drawer.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      var add = e.target.closest('[data-upsell-add]');
      if (minus || plus) {
        var row = e.target.closest('[data-line]');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-line'), 10);
        var current = parseInt(row.querySelector('[data-qty-val]').textContent, 10);
        changeLine(line, current + (plus ? 1 : -1));
      } else if (add) {
        add.disabled = true;
        var addLabel = add.textContent;
        addVariant(add.getAttribute('data-upsell-add'), 1)
          .catch(function (err) {
            add.textContent = (err && err.status === 422) ? 'Unavailable' : 'Try again';
            setTimeout(function () { add.textContent = addLabel; }, 2500);
          })
          .finally(function () { add.disabled = false; });
      }
    });

    // upsell rail arrows
    var prev = drawer.querySelector('[data-upsell-prev]');
    var next = drawer.querySelector('[data-upsell-next]');
    function scrollRail(dir) {
      var card = railEl.querySelector('[data-upsell-item]:not([hidden])');
      var step = card ? card.offsetWidth + 14 : 280;
      railEl.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollRail(-1); });
    if (next) next.addEventListener('click', function () { scrollRail(1); });

    // PDP buy forms -> AJAX add + open drawer
    document.querySelectorAll('form.p2-buy__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var idInput = form.querySelector('[name="id"]');
        if (!idInput) return; // fall through to normal submit
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
        addVariant(idInput.value, 1)
          .then(function () { open(); })
          .catch(function () { window.location.href = '/cart'; })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
          });
      });
    });

    // initial badge state
    refresh();
  });
})();
